/**
 * Simple Features exception
 */
export class SFException extends Error {
	/**
	 * Constructor
	 */
	public constructor (...args) {
		super(...args)
	}
}
